import { use } from 'echarts/core';
import { SVGRenderer } from 'echarts/renderers';
import { GaugeChart, BarChart, PieChart, LineChart, ScatterChart } from 'echarts/charts';
import {
  GridComponent,
  TooltipComponent,
  LegendComponent,
} from 'echarts/components';

use([
  SVGRenderer,
  GaugeChart,
  BarChart,
  PieChart,
  LineChart,
  ScatterChart,
  GridComponent,
  TooltipComponent,
  LegendComponent,
]);
